import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { formatSecondsToHHMMSS } from '@/utils/helpers'
import './Timer.scss'

const Timer = (props) => {
  const { className, timeRemaining, ...rest } = props

  return (
    <div {...rest} className={cx('Timer', className)}>
      {formatSecondsToHHMMSS(timeRemaining)}
    </div>
  )
}

Timer.propTypes = {
  className: PropTypes.string,
  timeRemaining: PropTypes.number.isRequired,
}

Timer.defaultProps = {
  className: '',
}

export default Timer
